import React from 'react';

function Contact(props) {
  return (
    <div className="Contact">
      <p className="Contact_title">Contacto</p>
      <div className="Contact_container">
        <p className="Contact_subtitle">Teléfono</p>
        <a className="Contact_content" href="tel:525541606061">52-55-4160-6061</a>
      </div>
      <div className="Contact_container">
        <p className="Contact_subtitle">Correo electrónico</p>
        <p className="Contact_content">hola@contactaabogado.com</p>
      </div>
      <div className="Contact_container">
        <p className="Contact_subtitle">Dirección</p>
        <p className="Contact_content">
          Hamburgo #70, Juárez,<br />
          Cuahtémoc, C.P. 06600,<br />
          CDMX.
        </p>
      </div>
      
    </div>
  );
}

export default Contact;
